<template>
  <section class="bg-no-repeat bg-center bg-top lg:bg-contain pt-24 lg:pt-28 xxl:pt-56">
    <div class="container grid grid-rows-auto lg:grid-rows-1 lg:grid-cols-2 lg:gap-12">
      <div class="flex flex-col w-full lg:w-10/12 xxl:w-8/12">
        <read-btn
          class="hidden lg:block"
        />
        <h1 class="hidden lg:block text-white text-2xl lg:text-4xl" v-text="title"/>
        <h2 v-if="subtitle" class="hidden lg:block text-white font-semi text-lg pt-2">{{ subtitle }}</h2>
        <p class="lg:mt-28 leading-loose" v-html="content"/>
      </div>
      <div class="row-start-1 lg:col-start-2">
        <read-btn
          class="lg:hidden"
        />
        <h1 class="lg:hidden text-white text-2xl lg:text-4xl" v-text="title"/>
        <h2 v-if="subtitle" class="lg:hidden text-white font-semi text-lg pt-2 mb-3">{{ subtitle }}</h2>
        <img :src="imageUrl || ''" alt="Datalead" class="w-full -ml-4 lg:ml-0">
      </div>
    </div>
  </section>
</template>

<script>
import ReadBtn from '~/layouts/partials/ReadBtn';

export default {
  components: {
    ReadBtn,
  },
  props: {
    imageUrl: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="sass" scoped>
section
  background-image: url("~assets/img/bg-sector.svg")
</style>
